module.exports = __webpack_public_path__ + "img/2.af5421f6.jpg";